/* Drag-to-scroll for horizontal tracks */
document.querySelectorAll('.track').forEach(track => {
  let isDragging = false, startX, scrollLeft;
  track.addEventListener('mousedown', e => {
    isDragging = true;
    startX = e.pageX - track.offsetLeft;
    scrollLeft = track.scrollLeft;
  });
  track.addEventListener('mouseleave', () => isDragging = false);
  track.addEventListener('mouseup', () => isDragging = false);
  track.addEventListener('mousemove', e => {
    if (!isDragging) return;
    e.preventDefault();
    track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.4;
  });
});

/* Variant picker — update price display when variant changes */
const variantSelect = document.querySelector('.variant-select');
const priceDisplay = document.querySelector('.price-display');
if (variantSelect && priceDisplay) {
  variantSelect.addEventListener('change', () => {
    const selected = variantSelect.options[variantSelect.selectedIndex];
    const price = selected.dataset.price;
    if (price) priceDisplay.textContent = price;
  });
}
